
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/need",
      function () {
        return require("private-next-pages/need.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/need"])
      });
    }
  